export default {"src":"https://s.sylndr.com/c-00317d6/_next/static/media/sedan.f2a9d469.svg","height":28,"width":88,"blurWidth":0,"blurHeight":0};